import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { segment } from '@/lib/analytics/segment';
import { useResolvedProductSlug } from '@/hooks/useResolvedProductSlug';

export function useSegmentPageTracking() {
  const { pathname } = useLocation();
  const productSlug = useResolvedProductSlug();
  const segmentTrackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    // Avoid duplicate page tracking in dev (StrictMode double-invoke)
    if (segmentTrackedPathRef.current === pathname) return;

    segmentTrackedPathRef.current = pathname;

    // Pre-questionnaire has custom page tracking for Segment; prevent double tracking
    if (/^\/products\/[^/]+\/pre_questionnaire$/.test(pathname)) return;

    segment.page(productSlug ? { product_slug: productSlug } : undefined);
  }, [pathname, productSlug]);
}
